import { render, staticRenderFns } from "./TheMyFavoritesRemoveProductDialog.vue?vue&type=template&id=5f7d38c8&scoped=true"
import script from "./TheMyFavoritesRemoveProductDialog.vue?vue&type=script&lang=js"
export * from "./TheMyFavoritesRemoveProductDialog.vue?vue&type=script&lang=js"
import style0 from "./TheMyFavoritesRemoveProductDialog.vue?vue&type=style&index=0&id=5f7d38c8&prod&lang=scss&scoped=true"
import style1 from "./TheMyFavoritesRemoveProductDialog.vue?vue&type=style&index=1&id=5f7d38c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7d38c8",
  null
  
)

export default component.exports